import { Injectable } from '@angular/core';
import {GeneralResponse, Offre} from '../../parametre/parametre.model';
import {map} from 'rxjs/operators';
import {AuthService} from '../../securite/service/auth.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {ToasterService} from '../../../globalServices/toaster.service';
import {Observable, Subject} from 'rxjs';
import {Candidature} from '../models/candidature.model';
import {CandidatService} from '../../candidat/services/candidat.service';

@Injectable({
  providedIn: 'root'
})
export class CandidatureService {
  public candidatures:  Candidature[]=[];
  candidatureSubject = new Subject<Candidature[]>();
    isLoadingCandidature=true;

  candidature_selected: Candidature;
  public candtTotal = {
    icon: "tag",
    counter: 0,
    name: "Toutes les candidatures",
    font: "primary",
    pr: "+70",
  };
  public candtEncours = {
    icon: "tag",
    counter: 0,
    name: "Candidatures en cours",
    font: "primary",
    pr: "+70",
  };
  public candtAccepter = {
    icon: "tag",
    counter: 0,
    name: "Candidatures acceptées",
    font: "primary",
    pr: "+70",
  };
  public candtRefuser = {
    icon: "tag",
    counter: 0,
    name: "Candidatures refusées",
    font: "primary",
    pr: "+70",
  };

  constructor(
      private authservice: AuthService,
      private http: HttpClient,
      private router: Router,
      private toastr: ToasterService,
      public candidatService: CandidatService,

  ) { }

  getCandidatureByUser(user_id: number) {
      this.isLoadingCandidature=true;
  return this.http.post<GeneralResponse>(this.authservice.urlApi + '/candidature/list', {
      'user_id': `${user_id}`
    }, {headers:this.authservice.getHeaders()}).pipe(
        map((response: GeneralResponse) => {
          this.isLoadingCandidature=false;

          const data = response.data as Candidature[]; // Type assertion for clarity
            // //console.log('response candidatures', response);

          this.candtTotal = {
            icon: "tag",
            counter: data.length,
            name: "Toutes les candidatures",
            font: "primary",
            pr: "0",
          };
          this.candtEncours  = {
            icon: "tag",
            counter: data.filter(candidature => candidature.etat === 'E').length,
            name: "Candidatures en cours",
            font: "primary",
            pr: "0",
          };
          this.candtAccepter = {
            icon: "tag",
            counter: data.filter(candidature => candidature.etat === 'A').length,
            name: "Candidatures acceptées",
            font: "primary",
            pr: "0",
          };
          this.candtRefuser = {
            icon: "tag",
            counter: data.filter(candidature => candidature.etat === 'R').length,
            name: "Candidatures refusées",
            font: "primary",
            pr: "0",
          };
            return data;
        })
    )
      this.isLoadingCandidature=false;

  }

  emitCandidature() {
    this.candidatureSubject.next(this.candidatures);
  }

  createCandidature(candidatData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.authservice.getToken()}`
      })
    };

    return this.http.post<any>(this.authservice.urlApi + '/candidature/add', candidatData, {headers:this.authservice.getHeaders()});
  }
  updateCandidature(candidatData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.authservice.getToken()}`
      })
    };

    return this.http.post<any>(this.authservice.urlApi + '/candidature/update', candidatData, {headers:this.authservice.getHeaders()});
  }
  validerCandidature(candidatData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.authservice.getToken()}`
      })
    };

    return this.http.post<any>(this.authservice.urlApi + '/candidature/valider', candidatData, {headers:this.authservice.getHeaders()});
  }
}
